class WebAPIError extends Error {
  constructor(path, error, method, status) {
    super();

    this.name = 'WebAPIError';
    this.method = method;
    this.path = path;
    this.code = error.code;
    this.httpStatus = status;
  }
}

export default WebAPIError;
